import { Dropdown } from 'antd'
import type { MenuProps } from 'antd'
import {
  CheckCircleOutlined,
  MoreOutlined,
  PauseOutlined,
  PoweroffOutlined,
} from '@ant-design/icons'
import { createElement, ReactElement } from 'react'
import { BulkAction, Confirmable } from '../../models'
import { ComponentController } from './component_controller'
import { dispatcher } from '../pub_controller'

type IconType = 'activate' | 'deactivate' | 'suspend'

const iconMap: Record<IconType, ReactElement> = {
  activate: createElement(CheckCircleOutlined),
  deactivate: createElement(PoweroffOutlined),
  suspend: createElement(PauseOutlined),
}

type BulkActionsDropdownProps = {
  onClick: any
  actions?: {
    iconType: IconType
    label: string
    path: string
    body: string
    confirmationTitle: string
    confirmationMessage: string
  }[]
  confirmBulkAction: (options: object) => void
}

const BulkActionsDropdown = ({
  actions,
  confirmBulkAction,
  onClick,
}: BulkActionsDropdownProps) => {
  const items: MenuProps['items'] = (actions || []).map(
    ({
      iconType,
      label,
      path,
      body,
      confirmationTitle,
      confirmationMessage,
    }) => ({
      icon: iconMap[iconType],
      key: label,
      label: createElement(
        'a',
        {
          onClick: () =>
            confirmBulkAction({
              path,
              body,
              confirmationTitle,
              confirmationMessage,
            }),
        },
        label,
      ),
    }),
  )

  const icon = createElement(MoreOutlined)
  return createElement(
    Dropdown,
    { menu: { items }, trigger: ['click'], arrow: true },
    icon,
  )
}

export class BulkActionsDropdownController extends ComponentController {
  static values = { pubChannel: String }
  declare readonly pubChannelValue: string

  get component() {
    return BulkActionsDropdown
  }

  get initialProps() {
    return {
      ...this.propsFromData,
      confirmBulkAction: this.confirmBulkAction.bind(this),
      onClick: this.openModal.bind(this),
    }
  }

  openModal(status: string) {
    dispatcher(this, status, 'bulk-actions', 'true')
  }

  confirmBulkAction({ path, body, confirmationTitle, confirmationMessage }) {
    const confirmable = new Confirmable({
      pubChannel: this.pubChannelValue,
      pubAs: 'bulk-action',
      detail: new BulkAction({ path, body }),
      confirmationTitle,
      confirmationMessage,
    })
    dispatcher(this, 'confirm-operation', this.pubChannelValue, confirmable)
  }
}
